export const headersExportVacations = [
    
    { v: "Identificación", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Nombre completo", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Base", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Area", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Campaña", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Estado Campaña", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Publicada", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Fecha Inicio", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Fecha Fin", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Fecha Creación", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Estado Solicitud", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Usuario Actualizacion", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Fecha Actualizacion", t: "s", s: { font: { sz: 12, bold: true } } }
];